// 登录页
import React, { useEffect, useRef, useState } from 'react';
import { Card, Form, Input, Checkbox, Button, Flex, Tooltip } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { fetchLogin } from '@/apis/user';
import { useNavigate, Link } from 'react-router-dom';
import logo from '@/assets/logo.png';
import { useSelector } from 'react-redux';
import { message } from 'antd';
import { fetchUserInfo } from '@/apis/user';
import authSession from '@/utils/authSession';
import StandaloneBack from '@/components/standaloneback';

import './index.scss';

const Login = () => {
  // 配置初始化
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false); // 控制按钮禁用
  const submitting = useRef(false);
  const { isAuthenticated } = useSelector(state => state.user);
  const loginDisabled = loading || isAuthenticated;

  // 处理用户来到登录页的情况
  useEffect(() => {
    // 认证更新可能重建本页；跳转不负责发提示，避免被误判为重复登录。
    if (isAuthenticated) navigate('/', { replace: true });
  }, [isAuthenticated, navigate]);
  // 用户点击登录后处理登录请求
  const onFinish = async (values) => {
    if (submitting.current || isAuthenticated) return;
    submitting.current = true;
    try {
      // 禁用登录按钮，防止用户多次点击造成重复请求
      setLoading(true);
      const result = await dispatch(fetchLogin(values));
      if (result?.success) {
        // 登录成功
        const generation = authSession.getGeneration();
        // 记住用户名
        if (values.remember) {
          localStorage.setItem('username', values.username);
        } else {
          localStorage.removeItem('username');
        }
        // 登录成功后，获取用户信息
        await dispatch(fetchUserInfo());
        if (authSession.getGeneration() !== generation) return;
        message.success({ key: 'login-success', content: '登录成功' });
        navigate('/', { replace: true });
      } else {
        // 登录失败
        message.error(result?.error || '登录失败，请检查用户名和密码');
      }
    } catch (error) {
      message.error('登录失败，请稍后重试');
    } finally {
      submitting.current = false;
      // 登录请求完毕，解禁登录按钮
      setLoading(false);
    }
  };
  return (
    <div className="login standalonePage">
      <StandaloneBack disabled={loading} />
      {/* 登录框上方 logo */}
      <div className="demo-logo">
        <Link to="/">
          <Tooltip title="点击返回首页">
            <img src={logo} alt="" height={64} />
          </Tooltip>
        </Link>
      </div>
      {/* 登录框 */}
      <Card title="登录账号" variant="borderless">
        <Flex justify="center">
          <Form
            name="login"
            aria-label="登录表单"
            initialValues={{
              remember: true,
              username: localStorage.getItem('username') || '',
            }}
            style={{ width: '90%' }}
            onFinish={onFinish}
          >
            {/* 用户名输入框 */}
            <Form.Item
              name="username"
              rules={[{ required: true, message: '请输入用户名!' }]}
            >
              <Input prefix={<UserOutlined />} placeholder="请输入用户名" disabled={loginDisabled} />
            </Form.Item>
            {/* 密码输入框 */}
            <Form.Item
              name="password"
              rules={[{ required: true, message: '请输入密码!' }]}
            >
              <Input.Password prefix={<LockOutlined />} type="password" placeholder="请输入密码" disabled={loginDisabled} />
            </Form.Item>
            {/* 记住用户名选择框 */}
            <Form.Item>
              {/* 控制记住用户名和忘记密码位于同一行 */}
              <Flex justify="space-between" align="center">
                <Form.Item name="remember" valuePropName="checked" noStyle>
                  <Checkbox>记住用户名</Checkbox>
                </Form.Item>
                {/* 忘记密码链接，后续开发 */}
                <Link to="/forgot-password">忘记密码</Link>
              </Flex>
            </Form.Item>
            {/* 登录按钮 */}
            <Form.Item>
              <Button block type="primary" htmlType="submit" loading={loading} disabled={loginDisabled}>
                登录账号
              </Button>
            </Form.Item>
            {/* 跳转注册页 */}
            暂无账号？ <Link to="/register">立即注册</Link>
          </Form>
        </Flex>
      </Card>
    </div>
  );
}
export default Login;
